<app-header [title]="title"></app-header>
<div class="container-fluid">
  <div class="row p-0 box-heightSD">
    <div class="col-md-12 pt-8">
      <span class="col-md-12 pull-left pl-7">
        <form [formGroup]="dashboard">
          <span class="pull-left mr-10 mt-15 label-std control-label b-600 w-auto">Client List</span>
          <span class="pull-left mr-10 pt-3 wt-15">
            <select class="form-control" formControlName="ClientId" (change)="getClientName()">
              <option [selected]="ClientList.length>1" disabled>Select</option>
              <option *ngFor="let Client of ClientList" [value]="Client.Client_Id" [selected]="Client.selected">
                {{Client.Client_Name}}
              </option>
            </select>
          </span>
          <span>
            <button class="mt-3 btn blue square-btn blue-hover btn-txt mr-10 btn-default" data-toggle="modal"
              data-target=".account-list" (click)="search()" [disabled]="!dashboard.valid">Search</button>
          </span>
          <span (click)="openModal()" *ngIf="dashboardData && dashboardData.length>0"
            style="float: right;justify-content: center;align-items: center;">
            <i title="Heatmap Calulation Information" style="cursor: pointer;color:#388eca"
              class="fa fa-info-circle fa-2x" aria-hidden="true"></i>
          </span>
        </form>
      </span>
    </div>
    <div class="col-md-12 supervisor-dash-tbl">
      <label class="error" *ngIf="submitStatus==false && (dashboardData==null || dashboardData.length==0)">
        There is no Data for Client :- {{ Client_Name}}</label>
      <div class="" style="border:0px solid #000;">

        <!-- <div class="sticky-table sticky-ltr-cells border-0 table-hight super-dash-table"
                *ngIf="dashboardData!=null && dashboardData.length>0"> -->
        <div class="sticky-table sticky-ltr-cells border-0 table-hight super-dash-table"
          *ngIf="dashboardData!=null && dashboardData.length>0">
          <table>
            <tr>
              <th rowspan="2">Buckets</th>
              <th rowspan="2">To Be Concluded</th>
              <th rowspan="2">Rejections</th>
              <th colspan="2">Paid</th>
              <th colspan="4">Denials</th>
              <th colspan="4">No Response</th>
            </tr>
            <tr>
              <th>EOB Available</th>
              <th>No EOB</th>


              <th>Provider Issue</th>
              <th>Payer Issue</th>
              <th>Patient Issue</th>
              <th>Coding Issue</th>


              <th>Website</th>
              <th>IVR</th>
              <th>Fax</th>
              <th>Calling</th>
            </tr>

            <tr class="t-bold" *ngFor="let data of dashboardData">
              <td> {{data.Bucket_Label  }} </td>

              <td
                [style.background]="(data.report && data.report.To_Be_Concluded ? data.report.To_Be_Concluded : '#fff')"
                (click)="opeAllocatedCount(data,'To_Be_Concluded')"
                [ngStyle]="{'text-decoration': (data.Bucket_Label=='Allocated ##' && data.To_Be_Concluded>0) ? 'underline':'none','color': (data.Bucket_Label=='Allocated ##' && data.To_Be_Concluded>0) ? 'blue':'#000'}">
                {{data.To_Be_Concluded  }} </td>

              <td (click)="opeAllocatedCount(data,'Rejections')"
                [style.background]="(data.report && data.report.Rejections ? data.report.Rejections : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.Rejections>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.Rejections>0 ? 'blue':'#000'}">
                {{data.Rejections  }} </td>

              <td (click)="opeAllocatedCount(data,'Paid_EOB_Availble')"
                [style.background]="(data.report && data.report.Paid_EOB_Availble ? data.report.Paid_EOB_Availble : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.Paid_EOB_Availble>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.Paid_EOB_Availble>0 ? 'blue':'#000'}">
                {{data.Paid_EOB_Availble  }}
              </td>

              <td (click)="opeAllocatedCount(data,'Paid_NO_EOB')"
                [style.background]="(data.report && data.report.Paid_NO_EOB ? data.report.Paid_NO_EOB : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.Paid_NO_EOB>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.Paid_NO_EOB>0 ? 'blue':'#000'}">
                {{data.Paid_NO_EOB  }}
              </td>

              <td (click)="opeAllocatedCount(data,'Denials_Provider_Issue')"
                [style.background]="(data.report && data.report.Denials_Provider_Issue ? data.report.Denials_Provider_Issue : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.Denials_Provider_Issue>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.Denials_Provider_Issue>0 ? 'blue':'#000'}">
                {{data.Denials_Provider_Issue  }} </td>

              <td (click)="opeAllocatedCount(data,'Denials_Payer_Issue')"
                [style.background]="(data.report && data.report.Denials_Payer_Issue ? data.report.Denials_Payer_Issue : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.Denials_Payer_Issue>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.Denials_Payer_Issue>0 ? 'blue':'#000'}">
                {{data.Denials_Payer_Issue  }} </td>
              <td (click)="opeAllocatedCount(data,'Denials_Patient_Issue')"
                [style.background]="(data.report && data.report.Denials_Patient_Issue ? data.report.Denials_Patient_Issue : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.Denials_Patient_Issue>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.Denials_Patient_Issue>0 ? 'blue':'#000'}">
                {{data.Denials_Patient_Issue  }} </td>
              <td (click)="opeAllocatedCount(data,'Denials_Coding_Issue')"
                [style.background]="(data.report && data.report.Denials_Coding_Issue ? data.report.Denials_Coding_Issue : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.Denials_Coding_Issue>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.Denials_Coding_Issue>0 ? 'blue':'#000'}">
                {{data.Denials_Coding_Issue  }} </td>
              <td (click)="opeAllocatedCount(data,'No_Response_Website')"
                [style.background]="(data.report && data.report.No_Response_Website ? data.report.No_Response_Website : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.No_Response_Website>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.No_Response_Website>0 ? 'blue':'#000'}">
                {{data.No_Response_Website  }} </td>
              <td (click)="opeAllocatedCount(data,'No_Response_IVR')"
                [style.background]="(data.report && data.report.No_Response_IVR ? data.report.No_Response_IVR : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.No_Response_IVR>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.No_Response_IVR>0 ? 'blue':'#000'}">
                {{data.No_Response_IVR  }} </td>
              <td (click)="opeAllocatedCount(data,'No_Response_Fax')"
                [style.background]="(data.report && data.report.No_Response_Fax ? data.report.No_Response_Fax : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.No_Response_Fax>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.No_Response_Fax>0 ? 'blue':'#000'}">
                {{data.No_Response_Fax  }} </td>
              <td (click)="opeAllocatedCount(data,'No_Response_Calling')"
                [style.background]="(data.report && data.report.No_Response_Calling ? data.report.No_Response_Calling : '#fff')"
                [ngStyle]="{'text-decoration': data.Bucket_Label=='Allocated ##' && data.No_Response_Calling>0 ? 'underline':'none','color': data.Bucket_Label=='Allocated ##' && data.No_Response_Calling>0 ? 'blue':'#000'}">
                {{data.No_Response_Calling  }} </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- <app-allocated-count-modal *ngIf="showAllocatedCountModal==true" [AllocatedCountsData]="activeAllocatedCount"
    (close)="closeAllocatedCount()"></app-allocated-count-modal> -->
<app-allocated-count-modal *ngIf="showAllocatedCountModal==true" [Client_ID]="dashboard.value['ClientId']"
  [AllocatedCountsData]="activeAllocatedCount" (close)="closeAllocatedCount()" [activeBucket]="activeBucket">
</app-allocated-count-modal>
<app-concluder-help-image *ngIf="showInfomodal" [allData]="dashboardData" (close)="closeModal()">
</app-concluder-help-image>
<!-- <app-concluder-help-image *ngIf="showInfomodal" (close)="closeModal()"></app-concluder-help-image> -->
